module.exports = __webpack_public_path__ + "img/Responsability-Our Employees.8d37b0d7.jpg";